import type { DocMatrixLink } from './api/docmatrix.model';

/**
 * Egy linkelés vagy unlinkelés eredménye, amivel a megnyitott fájllisták hálózati kérés
 * nélkül frissíthetők. A művelet mindig egy dokumentum-mátrix elemhez köt vagy old el
 * több fájlt, ezért a linkleíró közös, csak az érintett fájlok listája változik.
 */
export type LinkPatch =
    | {
        kind: 'link';
        /** Az érintett fájlok azonosítói (`filemanager_file_id`). */
        fileIds: number[];
        /** A létrejött link. Az `id` ideiglenes, a következő valódi listázás felülírja. */
        link: DocMatrixLink;
    }
    | {
        kind: 'unlink';
        /** Az érintett fájlok azonosítói (`filemanager_file_id`). */
        fileIds: number[];
        sourcemodelId: number;
        itemUuid: string;
    };

let tempLinkId = 0;

/**
 * Ideiglenes, negatív azonosító egy lokálisan felvett linkhez. A link-dialógus csak
 * `track` kulcsként használja az `id`-t, így elég, hogy a valós azonosítókkal ne ütközzön.
 */
export function nextTempLinkId(): number {
    return --tempLinkId;
}
